import { Outlet } from "react-router-dom";
import NavBar from "../../Components/website/NavBar";
import Footer from "../../Components/website/Footer/Footer";

export default function WebSite(){
    return(
      <div className="page">
        <div className="pageContent">
          <NavBar/>
          <Outlet/>
        </div>
        <Footer/>  
      </div>
    );
}